import CardCvcInput from "@shared/modules/payments/common/CardCvcInput/CardCvcInput.web";
import CardExpiryInput from "@shared/modules/payments/common/CardExpiryInput/CardExpiryInput.web";
import CardNumberInput from "@shared/modules/payments/common/CardNumberInput/CardNumberInput.web";
// eslint-disable-next-line import/no-cycle
import AuthorizePaymentGateway from "@shared/modules/payments/gateways/AuthorizePaymentGateway/AuthorizePaymentGateway";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { usePaymentManager } from "../../../contexts/PaymentManagerContext";
import { AuthorizeElementSharedProps } from "./AuthorizeElement.props";

const AuthorizeElement = forwardRef<
  HTMLInputElement | null,
  AuthorizeElementProps
>(function AuthorizeElement({ element, onChange }, ref) {
  const { manager } = usePaymentManager();

  const inputRef = useRef<HTMLInputElement | null>(null);

  const gateway = manager.handler?.gateway;
  const authorizeGateway =
    gateway instanceof AuthorizePaymentGateway ? gateway : undefined;
  const elementsReady = authorizeGateway?.elementsInstance;

  useEffect(() => {
    if (!authorizeGateway?.elementsInstance) return;
    if (!inputRef.current) return;

    if (!authorizeGateway.elementsInstance.hasElement(element)) {
      authorizeGateway.elementsInstance.create(element);
      authorizeGateway.elementsInstance.mount(element, inputRef.current);
    }
  }, [authorizeGateway, elementsReady, element]);

  useEffect(() => {
    return () => {
      if (!manager.handler?.gateway) return;

      if (manager.handler.gateway instanceof AuthorizePaymentGateway) {
        manager.handler?.gateway?.elementsInstance?.unmount(element);
      }
    };
  }, []);

  /**
   * Expose the internal input ref
   */
  useImperativeHandle<
    HTMLInputElement | null,
    HTMLInputElement | null
  >(ref, () => inputRef.current, []);

  if (element === "cardNumber") {
    return <CardNumberInput ref={inputRef} onChange={onChange} />;
  }

  if (element === "cardExpiry") {
    return <CardExpiryInput ref={inputRef} onChange={onChange} />;
  }

  if (element === "cardCvc") {
    return <CardCvcInput ref={inputRef} onChange={onChange} />;
  }

  return null;
});
export default AuthorizeElement;

type AuthorizeElementProps = AuthorizeElementSharedProps & {
  //
};
